<template>
  <div id="Contact">
    <Header msg="/goods" />
	<div id='goodsPage'>
		<div class='backBox' @click='back' style='cursor:pointer;'>
          <img :src="require('@/assets/icon-next2.png')" alt="">
          <div>返回</div>
    	</div>
		
    	<div class='goodsDetailBox'>
				<div class='gDbox'>
					<img :src="gD.index_img" :alt="gD.goods_name" class="gDimg">
					<div class="gDcont">
						<div class='gDname'>{{gD.goods_name}}</div>
						<div class='gDdayUse'>推荐服用：每日{{gD.day_use}}颗</div>
						<div class='gDcat'>
							<div v-for='item in gD.cat' class='gDcatBox'>
								<img :src="item.url">
								<div>{{item.title}}</div>
							</div>
						</div>
						<div class='gDprice'>¥{{gD.shop_price*gD.day_use*30}}<span>/月</span></div>
						<div class='gDbtn'>
	                         <div class='whiteBtn' @click='openCart' style='cursor:pointer;'>查看橘袋</div>
	                         <div class='redBtn' @click='addCart' :data-id='gD.id' :data-add='computCart' v-if='computCart' style='cursor:pointer;'>加入橘袋</div>
	                         <div class='grayBtn' @click='addCart' :data-id='gD.id' :data-add='computCart' v-if='!computCart' style='color:#fff;border:1px solid #eee;cursor:pointer;'>已加入橘袋</div>
						</div>
					</div>
				</div>
				<div class='gdBox'>
					<div class="gdImg">
						<img :src="goodsDetailImg" :alt="gD.goods_name" >
					</div>
					
					<div class="gdCont">
							<div class='gdName'>{{gD.goods_name}}</div>
							<div class='gdCat'>
								<div v-for='item in gD.cat' class='gdCatBox'>
									<img :src="item.url">
									<div>{{item.title}}</div>
								</div>
							</div>
							<div class='gdLabel'>
								<div class='gdLabelBox' v-for='item in gD.goods_label'>
									<img :src="item.img_url">
									<div>{{item.title}}</div>
								</div>
							</div>
							<div class="gdLabelBtn"  @click='showNutrition' style='cursor:pointer;'>
									<div style='cursor:pointer;'>产品营养标签</div>
									<img :src="require('@/assets/icon-next4.png')" style='cursor:pointer;'>
							</div>
							<div class='gdTitle'>
									<div class="gdTitleName">每日用量</div>
									<div class='gdTitleBox'>
										<img :src="require('@/assets/icon-yao.png')">
										<div>{{gD.day_use}}颗</div>
									</div>
							</div>

							<div class='gdTitle'>
									<div class="gdTitleName">产品剂量</div>
									<div class='gdTitleBox' v-if='!moreSize'>
										<div class='gdWeight'>
											<div class="gdWeightSize">{{unitSize}}</div>
											<div class="gdWeightName">{{unitName}}</div>
										</div>
									</div>
									<div class='gdTitleBox2' v-if='moreSize'>
										<div class='gdWeight2' v-for='item in gD.goods_unit'>
											<div class="gdWeightSize">{{item.unit_size}}</div>
											<div class="gdWeightName">{{item.unit_name}}</div>
										</div>
									</div>
							</div>

							<div class='gdTitle'>
									<div class="gdTitleName">其他成分</div>
									<div class='gdTitleBox'>
										<div>{{gD.other_component}}</div>
									</div>
							</div>

							<div class='gdTitle'>
									<div class="gdTitleName">产品不包含</div>
									<div class='gdTitleBox'>
										<div>{{gD.exclusive}}</div>
									</div>
							</div>

							<div class='gdbtn'>
			                         <div class='whiteBtn' @click='openCart' style='cursor:pointer;'>查看橘袋</div>
			                         <div class='redBtn' style='cursor:pointer;'>加入橘袋</div>
							</div>
					</div>
				</div>
    	</div>
	</div>

	<div class="nutrition" @click='showNutrition' v-if='nutritionShow'>
		<img :src="gD.nutrition_img">
	</div>
    <Foot />
  </div>

</template>

<script>
// @ is an alias to /src
import Header from '@/components/header.vue'
import Foot from '@/components/foot.vue'

export default {
  name: 'Goods',
  components: {
      Header,
      Foot,
  },
  data:()=>{
  	return{
  		gD:{},
  		goodsDetailImg:"",
  		moreSize:false,
  		unitSize:"",
  		unitName:"",
  		nutritionShow:false,
  	}
  	
  },
  computed:{
    computCart(){
      let add = true
      this.$store.state.cartGoodsId.forEach((item)=>{
          if(item == this.gD.id){
            add =false
          }
      })
      return add
    }
  },
 beforeCreate:function(){
 	let goodsid = this.$route.query.id
 	let that = this
	let patt1 = /<img\s+[^><]*?src=([\'"])([^><]+?)\1[^><]*?>/g
	let arr =""
	let _parseImg = []
   
    this.axios({
            method: 'post',
            url: 'goods/goodsDetail',
            data: {
             goods_id: goodsid,
             member_id:51
            }
          }).then(res=>{
            console.log(res.data.goods_detail)
            that.gD = res.data.goods_detail
            arr = (res.data.goods_detail.goods_desc.match(patt1));
            if (arr){
	          arr.forEach((item) => {
	            item = item.split("src=")
	            item = item[1].split(" ")
	            item = "https://admin.xiaojudai.cn" + item[0].replace("\"", "").replace("\"", "");
	            _parseImg.push(item)
	          })
	         that.goodsDetailImg = _parseImg[0]
        	}
	           if(res.data.goods_detail.goods_unit.length<=1){
	           		that.moreSize = false
	           		that.unitSize = res.data.goods_detail.goods_unit[0].unit_size
	           		that.unitName = res.data.goods_detail.goods_unit[0].unit_name
	           }else{
	           		that.moreSize = true
	           }
          })
          $("html,body").animate({scrollTop:"0px"}, 10);
 },
  methods:{
	
	back(){
      this.$router.go(-1)
    },
    showNutrition(){
    	this.nutritionShow = !this.nutritionShow
    },
    openCart(){
        console.log(this.$store.state.orderStep)
        if( this.$store.state.orderStep>0){
         this.$store.commit("saveOrderStep",0)
        }else{
          this.$store.commit("saveOrderStep",1)
        }
     },
     addCart(e){
      this.$store.commit("saveCartNum",{cartNum:this.$store.state.cartNum,goodsId:e.target.dataset.id,add:e.target.dataset.add})

      if(e.target.dataset.add){
      	console.log(e)
        this.$store.commit("saveBall",{x:e.screenX,y:e.screenY})
      }
    }
  }
}
</script>
<style>
#Contact{
	width: 100%;
	height:100%;
}
#contactPage{

}
.bannerBox{
	width: 100%;
	height:640px;
	background-repeat: no-repeat;
	  background-size: 100%;
	  background-position:center;
	  -moz-background-size: 100% 100%;
}
.backBox{
  width: 90vw;
  margin: 0 auto;
  height:22px;
  color: #787878;
  position: relative;
  display:flex;
  padding: 80px 0 90px 10px;
}
.backBox img{
	transform:rotate(180deg);
	-ms-transform:rotate(180deg); 	/* IE 9 */
	-moz-transform:rotate(180deg); 	/* Firefox */
	-webkit-transform:rotate(180deg); /* Safari 和 Chrome */
	-o-transform:rotate(180deg); 	/* Opera */
	width: 10px;
	height:14px;
	margin-right: 6px;
	position: relative;
	top:3px;
}
.goodsDetailBox{
	width: 72vw;
	margin:0 auto;
}
.gDbox,.gdBox{
	display: flex;
	margin-bottom: 5vw;
	flex-wrap: wrap;
}
.gDimg{
	width: 492px;
	height:277px;
	display: block;
	margin-right: 5vw;
	margin-bottom: 2vw
}
.gDcont{
	text-align:left;
	position: relative;
}
.gDname{
	height:30px;
	font-size:22px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(20,20,20,1);
	line-height:30px;
	letter-spacing:1px;
	margin-bottom: 10px;
}
.gDdayUse{
	height:20px;
	font-size:14px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(109,114,120,1);
	line-height:20px;
	margin-bottom: 30px;
}
.gDcat{
	margin-bottom: 30px;
	display: flex;
}
.gDcatBox{
	width: 50px;
	margin-right: 10px;
}
.gDcatBox img{
	width: 32px;
	height:32px;
	display: block;
	margin:0 auto;
}
.gDcatBox div{
	height:20px;
	font-size:14px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(20,20,20,1);
	line-height:20px;
	text-align:center;
}
.gDprice{
	height:25px;
	font-size:18px;
	font-family:PingFangSC-Medium;
	font-weight:600;
	color:#C25E4D;
	line-height:25px;
	letter-spacing:1px;
}
.gDprice span{
	color: #787878;
	font-size: 14px;
	font-weight:400;
}
.gDbtn{
	display: flex;
	position: absolute;
	left: 0;
	bottom:0;
}
.gDbtn div{
	margin-right: 30px;
	width: 180px;
	height:40px;
	border:1px solid rgba(194,94,77,1);
}
.gdImg{
	width: 495px;
	min-height:2734px;
	margin-right: 5vw;
}
.gdImg img{
	display: block;
	width:100%;
	height:100%;
}
.gdCont{
	text-align:left;
	position: relative;
}
.gdName{
	height:40px;
	font-size:28px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(20,20,20,1);
	line-height:40px;
	letter-spacing:1px;
	padding: 61px 0 30px;
	margin-bottom: 30px;
}
.gdCat{
  display: flex;
  margin-bottom: 30px;
}
.gdCatBox{
   width: 50px;
	margin-right: 10px;
}
.gdCatBox img{
	width: 32px;
	height:32px;
	display: block;
	margin:0 auto;
}
.gdCatBox div{
	height:20px;
	font-size:14px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(20,20,20,1);
	line-height:20px;
	text-align:center;
}
.gdLabel{
	max-width: 440px;
	display:flex;
	flex-wrap: wrap;
	margin-bottom: 30px;
}
.gdLabelBox{
	width: 220px;
	display: flex;
	margin-bottom: 20px;
}
.gdLabelBox img{
	width: 50px;
	height:50px;
	margin-right: 10px;
}
.gdLabelBox div{
height:50px;
font-size:14px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(20,20,20,1);
line-height:50px;
}
.gdLabelBtn{
	width:280px;
	height:50px;
	background:rgba(255,255,255,1);
	border-radius:25px;
	border:1px solid rgba(187,187,187,1);
	padding: 14px;
	display: flex;
	box-sizing: border-box;
	justify-content: center;
	margin-bottom: 80px;
}
.gdLabelBtn div{
	height:22px;
	font-size:16px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(120,120,120,1);
	line-height:22px;
	letter-spacing:1px;
	margin-right: 10px;
}
.gdLabelBtn img{
	width: 10px;
	height:16px;
	position: relative;
	top:3px;
}
.gdTitle{
	margin-bottom: 30px;
}

.gdTitleName{
	height:22px;
	font-size:16px;
	font-family:PingFangSC-Regular;
	font-weight:600;
	color:rgba(20,20,20,1);
	line-height:22px;
	letter-spacing:1px;
	text-align:left;
	margin-bottom: 10px;
}
.gdTitleBox{
	width:460px;
	min-height:140px;
	background:rgba(255,255,255,1);
	border-radius:5px;
	border:3px solid rgba(229,229,229,1);
	padding: 40px;
	box-sizing: border-box;
}
.gdTitleBox2{
	width:460px;
	min-height:140px;
	background:rgba(255,255,255,1);
	border-radius:5px;
	border:3px solid rgba(229,229,229,1);
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;
}
.gdTitleBox img{
	display: block;
	margin:0 auto;
	width: 52px;
	height:26px;
	margin-bottom: 10px;
}
.gdTitleBox div{
	text-align:center;
	font-size:14px;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(120,120,120,1);
	line-height:20px;
}
.gdTitleBox .gdWeightSize{
	font-size:16px;
	font-family:PingFangSC-Medium;
	font-weight:600;
	color:rgba(20,20,20,1);
	line-height:22px;
	letter-spacing:1px;
}
.gdTitleBox2 .gdWeight2{
	width:227px;
	height:70px;
	border-bottom: 1px solid rgba(229,229,229,1);
	border-right:  1px solid rgba(229,229,229,1);
	box-sizing: border-box;
	text-align:center;
	padding: 10px;
}
.gdTitleBox2 .gdWeight2 .gdWeightSize{
	font-size:16px;
	font-family:PingFangSC-Medium;
	font-weight:600;
	color:rgba(20,20,20,1);
	line-height:22px;
	letter-spacing:1px;
}
.gdbtn{
	padding-top: 30px;
	display: flex;
}
.gdbtn div{
	margin-right: 30px;
	width: 180px;
	height:40px;
	border:1px solid rgba(194,94,77,1);
}



.nutrition{
	position: fixed;
	width: 100vw;
	height:100vh;
	background-color:#555;
	left: 0;
	top:0;
	z-index: 101;
	padding: 50px;
}

</style>